import { render } from "./Download.vue?vue&type=template&id=769d45ac&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import "./Download.vue?vue&type=style&index=0&id=769d45ac&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769d45ac"]])

export default __exports__